import { Route } from "react-router-dom";
import { Sentry } from "@/lib/sentry";

export const SentryRoute = Sentry.withSentryRouting(Route);
